<template>
  <div class="box">
    <!-- 左侧 -->
    <div :style="{'margin-left': '20px'}" class="fst-side sec">
      <div class="main-box">
        <div class="sec-side" :style="{'padding-bottom':'0','height':'90px','padding-left':'8px','border-bottom': '1px solid #d2d2d2','line-height':'75px','font-size':'20px'}">
          <div>{{$I18n("oline_service")}}
            <div @click="openSearchModal" :style="{'float':'right' ,'display':'inline-block','margin-right':'8px'}">
              <md-icon :style="{'cursor':'pointer'}">search</md-icon>
            </div>
          </div>
        </div>
        <div :style="{'display':'flex', 'align-items':'center'}">
          <md-field>
            <!-- 可修改 -->
            <md-select v-model="mainMenu">
              <md-option :value="0">{{$I18n("will_solved")}}</md-option>
              <md-option :value="2">{{$I18n("resolved")}}</md-option>
              <md-option :value="5">未激活设备</md-option>
              <md-option :value="6">一个月内设备</md-option>
              <md-option :value="7">半年内设备</md-option>
              <md-option :value="8">一年内设备</md-option>
              <md-option :value="9">一年外设备</md-option>
            </md-select>
          </md-field>
        </div>
        <div 
          v-for="item in feedback_list" 
          :key="item.id" 
          class="sec-side menu-item-box" 
          @click="() => {changeChat(item)}"
          :class="{'selected': selected_sub.id == item.id }"
        >
          <div>
            <icon-customer class="menu-item-img"/>
          </div>
          <div>
            <div class="menu-item-p">{{item.user_id}}</div>
            <div class="menu-item-p">{{item.create_time_str}}</div>
          </div>
          <div v-if="false" class="menu-item-count">99</div>
        </div>
        <pagination 
          :mini-size="true"
          :total="total" 
          v-model="page" 
          :style="{'justify-content': 'center','position':'absolute','bottom':'10px','width':'240px'}"
          :per-page="page_size" class="pagination-no-border" type= "info"/>
      </div>
    </div>
    <div class="chat-side">
      <div class="user-info-box" :style="{'display':'flex','flex-direction': selected_item.user_id ?'row' :'row-reverse',}">
        <div  v-if="selected_item.user_id"  :style="{'display':'flex','align-items':'center'}">
          <icon-customer class="menu-item-img"/>
        </div>
        <div  v-if="selected_item.user_id"  :style="{'padding':'16px 0 0px 10px','flex-grow': '1'}">
          <div :style="{'display':'flex','align-items':'center'}">
            <div :style="{'font-size':'18px','line-height':'36px','padding-right':'16px'}">{{selected_item.user_id}}</div>
            <md-field class="no_under_line" :style="{'max-width':'80px'}">
              <!-- 可修改 -->
              <md-select v-model="feedback_state" @click="openSelected(selected_sub.id)">
                <md-option value="1">{{$I18n("processed")}}</md-option>
                <md-option value="2">{{$I18n("pending")}}</md-option>
                <md-option value="3">{{$I18n("solved")}}</md-option>
              </md-select>
            </md-field>
          </div>
          <input class="user_remark"  :placeholder="'点击可输入备注'" v-model="user_remark"/>
        </div>
        <div :style="{
            'margin-right':'9spx',
            'display':'flex',
            'align-items': 'center',
          }">
          <md-button :style="{'margin':'0 !important', 'cursor': selected_item.user_id ?'pointer' :'not-allowed !important'}" class="md-info md-sm md-simple  md-just-icon" @click="toggleRightBox">
            <icon-user-info :style="{'width':'30px', 'height':'30px',}"/>
          </md-button>
        </div>
      </div>
      <div class="chat-box" id="chat-box">
        <div v-for="item in feedback_message" :key="item.id" :class="{'left_box': item.type === 1, 'right_box': (item.type === 2 || item.type === 3)}">
            <div class="name">{{item.user_id}}</div>
            <div v-if="item.type === 3" class="message">
              <p v-for="(msg,index) in item.content" :key="index" :style="{'margin': '4px 0'}">
                {{msg}}
              </p>
            </div>
            <div v-else class="message">{{item.content}}</div>
            <div class="time">{{item.create_time_str}}</div>
        </div>
      </div>
      <div class="chat-input md-layout" :style="{'clear':'both','display':'flex','flex-direction':'column'}">
        <div :style="{'text-align':'rigth'}"  v-if="specs.length > 0">
          <md-button :style="{'margin':'0 !important','cursor': selected_item.user_id ?'pointer' :'not-allowed !important'}" class="md-info md-sm md-simple  md-just-icon" @click="() => {if(selected_item.user_id){openGiftModal()}}">
            <icon-gift :style="{'width':'30px','height':'30px','color':'#3c4858'}" />
          </md-button>
        </div>
        <div :style="{'margin-left':'6px'}">
            <textarea class="chat-textarea" placeholder="输入信息" v-model="new_content"></textarea>
            <md-button :style="{'cursor': selected_item.user_id ?'pointer' :'not-allowed !important'}" @click="() => {if(selected_item.user_id && new_content){upload_feedback()}}" class="submit-mark md-round md-sm" :class="{'md-info':selected_item.user_id, 'md-default': !selected_item.user_id}">提交</md-button>
        </div>
      </div>
    </div>
    <div :style="{'overflow':'hidden' ,'transition':'width .4s','width':show_right_box? (mobileType ?'260px' :'423px') :'0px'}">
      
      <div class="mobile-side" v-if="mobileType " v-show="!!selected_sub.id">
        <div class="one-box">
          <div class="one-box-img">
            <img v-if="device_info.pk_img" :src="device_info.pk_img">
            <img v-else src="/img/image_placeholder.jpg">
          </div>
        </div>
        <div class="one-box-info">
          <div class="one-box-info-box">
            <label>设备型号:</label>
            <span v-if="device_info.pk_name">{{device_info.pk_name}}</span>
            <span v-else>未知</span>
          </div>
          <div class="one-box-info-box">
            <label>设备ID: </label>
            <span>{{selected_sub.uid}}</span>
          </div>
          <div class="one-box-info-box">
            <label>当前电量:</label>
            <span>{{device_info.power ?device_info.power :0}}%</span>
          </div>
          <div class="one-box-info-box">
            <label>Wifi:</label>
              <span>{{device_info.wifi_signal}}</span>
          </div>
        </div>
        <div class="right-line"></div>
        <div class="two-box">
          <div class="two-box-info-box">
            <label>用户: </label>
            <span>{{selected_sub.user_id}}</span>
          </div>
          <div class="two-box-info-box">
            <label>注册时间: </label>
            <span>2022-02-18</span>
          </div>
          <div class="two-box-info-box">
            <label>区域: </label>
            <span>{{device_info.zone ? $I18n(device_info.zone) : ""}}</span>
          </div>
          <div class="two-box-info-box">
            <label>系统: </label>
            <span>IOS</span>
          </div>
          <div class="two-box-info-box">
            <label>登录时间: </label>
            <span>{{device_info.update_time}}</span>
          </div>
        </div>
      </div>
      <div class="right-side" v-if="!mobileType " v-show="!!selected_sub.id">
        <div class="one-box">
          <div class="one-box-img">
            <img v-if="device_info.pk_img" :src="device_info.pk_img">
            <img v-else src="/img/image_placeholder.jpg">
          </div>
          <div class="one-box-info">
            <div class="one-box-info-box">
              <label>设备型号:</label>
              <span v-if="device_info.pk_name">{{device_info.pk_name}}</span>
              <span v-else>未知</span>
            </div>
            <div class="one-box-info-box">
              <label>设备ID: </label>
              <span>{{selected_sub.uid}}</span>
            </div>
            <div class="one-box-info-box">
              <label>当前电量:</label>
            <span>{{device_info.power ?device_info.power :0}}%</span>
            </div>
            <div class="one-box-info-box">
              <label>Wifi:</label>
              <span>{{device_info.wifi_signal}}</span>
            </div>
          </div>
        </div>
        <div class="right-line"></div>
        <div class="two-box">
          <div class="half-box two-box-info-box">
            <label>用户: </label>
            <span>{{selected_sub.user_id}}</span>
          </div>
          <div class="half-box two-box-info-box">
            <label>注册时间: </label>
            <span>2022-02-18</span>
          </div>
          <div class="half-box two-box-info-box">
            <label>区域: </label>
            <span>{{device_info.zone ? $I18n(device_info.zone) : ""}}</span>
          </div>
          <div class="half-box two-box-info-box">
            <label>系统: </label>
            <span>IOS</span>
          </div>
          <div class="two-box-info-box">
            <label>登录时间: </label>
            <span>{{device_info.update_time}}</span>
          </div>
        </div>
      </div>
    </div>
    <!-- 弹窗 -->
    <div>
      <modal key="good" v-show="gifModalOpen" @close="gifModalOpen = false" :mid-modal="true">
        <!-- 弹窗-头部 -->
        <template slot="header">
          <h4 class="modal-title">{{$I18n("tips")}}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="gifModalOpen = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <!-- 弹窗-主体 -->
        <template slot="body">
          <div :style="{'height':'390px'}">
            <h5 v-if="specs.length > 0" class="title">点击下面按钮赠送云存储</h5>
            <div v-if="specs.length > 0" class="good-main-box md-layout">
              <template v-for="spec in specs">
                <div class="md-layout-item md-size-33" :key="spec.id" @click="() => sendCloudToUser(spec)">
                  <div class="good-box md-layout">
                    <div class="md-layout-item md-size-50">
                      <div class="weigth-font"><span class="big-font">{{spec.months}}</span>个月</div>
                      <div>使用时间</div>
                    </div>
                    <div class="md-layout-item md-size-50">
                      <div class="weigth-font"><span class="big-font">{{spec.attrs.lifecycle}}</span>天</div>
                      <div>保存天数</div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <!-- 弹窗-底部按钮 -->
        <template slot="footer">
          <md-button @click="gifModalOpen = false" class="">{{$I18n("cancel")}}</md-button>
        </template>
      </modal>
      <modal key="main" v-show="modalOpen" @close="modalOpen = false" class="lg-modal">
        <!-- 弹窗-头部 -->
        <template slot="header">
          <h4 class="modal-title">{{$I18n("tips")}}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalOpen = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <!-- 弹窗-主体 -->
        <template slot="body">
          <div>{{$I18n("is_sure_send", sendCloud.name)}}</div>
        </template>
        <!-- 弹窗-底部按钮 -->
        <template slot="footer">
          <md-button @click="modal_submit" class="left-icon md-info">{{$I18n("sure")}}</md-button>
          <md-button @click="modalOpen = false" class="">{{$I18n("cancel")}}</md-button>
        </template>
      </modal>

      <modal key="search" v-show="searchModalOpen" @close="searchModalOpen = false" class="lg-modal">
        <!-- 弹窗-头部 -->
        <template slot="header">
          <h4 class="modal-title">{{$I18n("tips")}}</h4>
          <md-button class="md-simple md-just-icon md-round modal-default-button" @click="searchModalOpen = false">
            <md-icon>clear</md-icon>
          </md-button>
        </template>
        <!-- 弹窗-主体 -->
        <template slot="body">
          <modal-form-item :label='"用户名"' :required="true">
            <md-field >
              <md-input v-model="form.user_id"/>
            </md-field>
          </modal-form-item>
          <modal-form-item :label='"设备ID"' :required="true">
            <md-field >
              <md-input v-model="form.uid"/>
            </md-field>
          </modal-form-item>
          <modal-form-item :label='"备注"' :required="true">
            <md-field >
              <md-input v-model="form.remark"/>
            </md-field>
          </modal-form-item>
        </template>
        <!-- 弹窗-底部按钮 -->
        <template slot="footer">
          <md-button @click="go_search" class="left-icon md-info">{{$I18n("sure")}}</md-button>
          <md-button @click="searchModalOpen = false" class="">{{$I18n("cancel")}}</md-button>
        </template>
      </modal>
    </div>
  </div>

</template>
<script>
import { Pagination } from "@/components";
import { Modal } from '@/components';
import { nMonthsAgo , timestampToString } from "@/common/tools.js";
import { IconCustomer, IconUserInfo, IconGift } from "@/components/IconSvg";
export default {
  components: {
    Pagination,
    Modal,
    IconCustomer,
    IconUserInfo,
    IconGift,
  },
  data() {
    return {
      searchModalOpen : false,
      gifModalOpen : false,
      show_right_box: false,
      user_remark: "" ,
      new_remark : "" ,
      search:{
        user_id: "",
        uid: "",
        remark: "",
      },
      form:{
        user_id: "",
        uid: "",
        remark: "",
      },
      content:"",
      reget_interval:0,
      new_content:"",
      feed_type: 4,
      mainMenu:0,
      start : 0,
      end : 0,
      selected_sub: {},
      page: 1,
      total: 0,
      page_size: 10,
      feedback_list:[],
      feedback_message:[ ],
      good_list: [],
      mobileType: true,
      device_info : {},

      remark:"",
      feedback_state: 0,
      selected_item: {},

      selectId : 0,
      // 要赠送的商品的信息
      sendCloud:{},
      modalOpen : false,
    };
  },
  mounted : function() {
    this.api_getFeedback().then(() => {
      if(this.feedback_list.length > 0){
        this.selected_feedback(this.feedback_list[0])
          .then(() => {
            var div = document.getElementById('chat-box');
            div.scrollTop = div.scrollHeight;
          })
      }
    });
    window.addEventListener('resize',this.checkWindow);
    setTimeout(this.checkWindow, 100)
    // this.api_getPageData();
    this.reget_interval = setInterval(() => {
      this.api_getFeedback();
      if(this.selected_sub.id){
        this.api_getFeedbackDetail()
      }
    }, 5 *1000)
  },
  destroyed: function(){
    clearInterval(this.reget_interval)
  },
  watch: { 
    selected_feedback:{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    getFeedbackDetail:{
      handler(){
        return 
      },
      immediate: true,
      deep: true,
    },
    user_remark(newValue){
      this.new_remark = newValue
      let new_remark = newValue
      setTimeout(() => {
        if(this.new_remark === new_remark){
          this.saveRemark(new_remark);
        }
      } ,1000)
    },
    feedback_state(to, back){
      if(to === back || this.selectId !== this.selected_sub.id || !this.selectId){
        return
      }
      if(to && this.selected_sub.id){
        this.$api.modifyFeedbackRemarkAndState({
          remark: this.remark,
          id: this.selected_sub.id,
          state: to,
        })
          .then(this.$Then(() => {
            this.selected_item.state = to;
            this.api_getFeedback();
          }))
          .catch(this.$Catch(this.$I18n("get_error")))
      }
    },
    mainMenu(newValue){
      this.page = 1;
      this.selected_sub = {};
      this.selected_item = {};
      this.feedback_message = [];
      this.device_info = {};

      let now   = new Date();
      let start = 0;
      switch(newValue){
        case 0:
          this.feed_type=4;
          this.start = 0
          this.end = 0;
          break;
        case 1:
          this.feed_type=2;
          this.start = 0
          this.end = 0;
          break;
        case 2:
          this.feed_type=3;
          this.start = 0
          this.end = 0;
          break;
        case 5: // 未激活 (时间都为-1)
          this.feed_type = 0;
          this.start = -1;
          this.end = -1;
          break
        case 6: // 1个月内
          this.feed_type = 0;
          start = nMonthsAgo(1, now).split("-")
          this.start = parseInt(new Date(`${start[0]}-${start[1]}-${now.getDate()}`).getTime() / 1000);
          this.end = parseInt(new Date(nMonthsAgo(0, now)).getTime() / 1000);
          break
        case 7: // 半年内
          this.feed_type = 0;
          start = nMonthsAgo(6, now).split("-")
          this.start = parseInt(new Date(`${start[0]}-${start[1]}-${now.getDate()}`).getTime() / 1000);
          this.end = parseInt(new Date(nMonthsAgo(0, now)).getTime() / 1000);
          break
        case 8: // 1年内
          this.feed_type = 0;
          start = nMonthsAgo(12, now).split("-")
          this.start = parseInt(new Date(`${start[0]}-${start[1]}-${now.getDate()}`).getTime() / 1000);
          this.end = parseInt(new Date(nMonthsAgo(0, now)).getTime() / 1000);
          break
        case 9: // 1年前
          this.feed_type = 0;
          start = nMonthsAgo(6, now).split("-")
          this.start = 0
          this.end = parseInt(new Date(`${start[0]}-${start[1]}-${now.getDate()}`).getTime() / 1000);
          break
      }
      this.api_getFeedback().then(() => {
        if(this.feedback_list.length > 0){
          this.selected_feedback(this.feedback_list[0])
        }
      })
    },
    // page(){
    //   this.api_getFeedback()
    // },
    // feed_type(){
    //   this.api_getFeedback();
    // }
  },
  computed: {
    specs : function(){
      let res = this.good_list;
      return res.filter(item => {
        return item.months // && item.good_data.save_day_time
      }).map(item => {
        let res = {};
        item.attr.forEach(i => {
          res[i.key] = i.value;
        })
        return {
          ...item,
          attrs: res,
        }
      })
    },
  },
  methods: {
    toggleRightBox(){
      this.show_right_box = !this.show_right_box;
    },
    openGiftModal(){
      this.gifModalOpen = true;
    },
    openSearchModal(){
      this.searchModalOpen = true;
    },
    changeChat(item){
      this.selected_feedback(item)
        .then(() => {
          var div = document.getElementById('chat-box');
          div.scrollTop = div.scrollHeight;
        })
    },
    sendCloudToUser(spec){
      this.sendCloud = {
        name    : spec.name,
        user_id : this.selected_item.user_id,
        app_id  : this.selected_sub.app_id,
        uid     : this.selected_item.uid,
        spec_id : spec.id,
        buy_num : 1,
        pay_type: 4,
        fee_type: 2,
        channel : 1,
      }
      this.modalOpen = true;
    },
    modal_submit(){
      this.$api.pushPayList(this.sendCloud)
        .then(this.$Then(res => {
          this.$api.setPaymentOrder({
            comp_price   : res.data.comp_price,
            pay_order_id : res.data.pay_order_id,
            order_key    : res.data.order_key,
            order_name   : res.data.order_name,
            order_fee    : res.data.order_fee,
            timestamp    : res.data.timestamp,
            order_notify_url : res.data.order_notify_url,
            user_id : this.sendCloud.user_id,
            app_id  : this.selected_sub.app_id,
            uid     : this.sendCloud.uid,
            type     : 4,
            fee_type : 2,
          })
            .then(this.$Then(pay_res => {
              window.__regetBalace();
              if(pay_res.code != 200){
                throw new Error ("Request failed, CDOE: " + pay_res.code)
              }
              let count = 0;
              var sendCheckInfo = () => {
                this.$api.getOrderInfo({
                  pay_id: res.data.pay_order_id,
                })
                  .then(this.$Then(order_res => {
                    if(order_res.code != 200 || order_res.data.length == 0 || order_res.data[0].order_state != 1){
                      throw new Error ("Request failed, CDOE: " + order_res.code)
                    }
                    this.$successMsg(this.$I18n("send_succ"))
                    this.modalOpen = false;
                    this.gifModalOpen = false;
                  }))
                  .catch(this.$Catch("", () => {
                    count = count + 1
                    if(count <= 10){
                      setTimeout(sendCheckInfo, 200)
                    } else {
                      this.$errorMsg(this.$I18n("send_fail"));
                    }
                  }))
              }
              sendCheckInfo()
            }))
            .catch(this.$Catch(this.$I18n("send_fail")))

        }))
        .catch(this.$Catch(this.$I18n("send_fail")))
    },
    openSelected(get_id){
      this.selectId = get_id;
    },
    go_search(){
      this.page = 1;
      this.search = {
        ...this.form,
      }
      this.api_getFeedback().then(() => {
        this.searchModalOpen = false;
        if(this.feedback_list.length > 0){
          this.selected_feedback(this.feedback_list[0])
        } else {
          this.selected_sub = {}
          this.device_info = {}
          this.selected_item = {};
        }
      });
    },
    saveRemark(mark) {
      this.$api.modifyFeedbackRemarkAndState({
        id: this.selected_sub.id,
        state: this.selected_sub.state,
        remark: mark,
      })
        .then(this.$Then(() => {
          this.$successMsg(this.$I18n("edit_success"))
          this.selected_item.remark = mark;
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    },
    checkWindow() {
      this.mobileType = window.innerWidth <= 1600
    },
    selected_feedback(item){
      let state_name = "";
      switch(item.state){
        case 1:
          state_name = this.$I18n("processed")
          break;
        case 2:
          state_name = this.$I18n("pending")
          break;
        case 3:
          state_name = this.$I18n("resolved")
          break;
      }
      this.selected_sub = {
        ...item,
        state_name,
      }
      this.selected_item = item;
      return this.api_getFeedbackDetail()
        .then(() => {
          this.api_getDevice().then(() => {
            this.api_getGood();
          });
        });
    },
    api_getFeedbackDetail(){
      return this.$api.__getFeedbackDetail({
        user_id : this.selected_sub.user_id,
        uid     : this.selected_sub.uid,
        type    : 1,
        title_id: this.selected_sub.id,
      })
        .then(this.$Then(res => {
          this.feedback_message = res.data.map(item =>{
            let content = item.content
            if(item.type === 3 && content){
              let contentArray = JSON.parse(item.content.replaceAll("\n","<br/>"))

              content = contentArray.length === 0 
                ? this.$I18n("sorry_no_answer") + "<br/>" + this.$I18n("trun_cust")
                : contentArray.length === 1
                  ? contentArray[0]
                  : this.$I18n("bot_question_before") + "<br/>" + contentArray.join("<br/>")

              content = content.split("<br/>")
            }
            return {
              ...item,
              content,
              create_time_str: timestampToString(item.create_time * 1000),
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.feedback_message = [];
        }))
    },
    api_getDevice(){
      this.feedback_state = this.selected_sub.state + ""
      this.remark = this.selected_sub.remark
      return this.$api.getFeedbackDevice({
        uid     : this.selected_sub.uid,
      })
        .then(this.$Then(res => {
          if(res.data.length == 0){
            this.device_info = {};
            return 
          }
          if(res.data[0].attr){
            this.device_info = {
              ...res.data[0],
              ...JSON.parse(res.data[0].attr),
            }
          } else {
            this.device_info = {
              ...res.data[0],
            }
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.device_info = {};
        }))
    },
    api_getFeedback(){
      return this.$api.__getFeedbackList({
        ...this.search,
        type   : 1,
        state  : this.feed_type,
        page_no: this.page,
        page_size :10,
        gmt_start :this.start,
        gmt_end   :this.end,
      })
        .then(this.$Then(res => {
          this.total = res.count;
          this.feedback_list = res.data.map(item => {
            if(item.id == this.selected_item.id){
              this.selected_item = {
                ...item,
                create_time_str: timestampToString(item.update_time * 1000),
              }
            }
            return {
              ...item,
              create_time_str: timestampToString(item.update_time * 1000),
            }
          });
          return 
        }))
        .catch(this.$Catch(this.$I18n("get_error"), () => {
          this.total = 0;
          this.feedback_list = [];
        }))
    },
    api_getGood(){
      this.$api.getGood({
        app_id    : this.selected_sub.app_id,
        pk        : this.device_info.pk,
        spec_type : 1,
        category_id:101,
        link_type : 0,
      })
        .then(this.$Then(res => {
          this.good_list = res.data.map(item => {
            let attr = [];
            if(item.attr){
              let attrJSON = JSON.parse(item.attr)
              for(let key in attrJSON){
                attr.push({
                  key : key ,
                  value: attrJSON[key],
                })
              }
            }
            if(item.specs){
              item.specs = item.specs.map(spec => {
                return {
                  ...spec,
                  attr,
                }
              })
            }
            return {
              ...item,
              attr,
            }
          });
        }))
        .catch(this.$Catch(this.$I18n("get_error"),() => {
          this.good_list = [];
        }))
    },
    go_back () {
      if(this.page > 1){
        this.page = this.page - 1;
        this.api_getFeedback();
      }
    },
    go_next () {
      if(this.page < Math.floor(this.total / this.page_size)){
        this.page = this.page + 1;
        this.api_getFeedback();
      }
    },
    upload_feedback(){
      this.$api.addNewFeedbackMsg({
        title_id : this.selected_sub.id,
        type     : 2,
        content  : this.new_content,
        user_id  : this.UserInfo.user_id,
      })
        .then(this.$Then(() => {
          this.new_content = "";
          this.selected_feedback(this.selected_sub)
            .then(() => {
              var div = document.getElementById('chat-box');
              div.scrollTop = div.scrollHeight;
            })

          this.api_getFeedback();
          if(this.selected_sub.id){
            this.api_getFeedbackDetail()
            this.api_getDevice()
          }
        }))
        .catch(this.$Catch(this.$I18n("get_error")))
    }
  },
}
</script>
<style lang="scss" scoped>
  .no_under_line::before, .no_under_line::after{
    background: unset !important;
  }
  .no_under_line{
    margin-top: 0 !important;
    padding-bottom: 0 !important;
  }
  .user_remark {
    height:30px;
    line-height:30px;
    font-size: 18px !important;
    display: block;
    flex: 1;
    border: none;
    background: none;
    font-family: inherit;
    font-size: 14px !important;
    color: #888888;
  }
  .user_remark::placeholder{
    color: #bbbbbb;
    font-size: 14px;
  }
  .chat-textarea{
    height: 32px;
    padding: 0;
    display: block;
    flex: 1;
    border: none;
    background: none;
    transition: .4s cubic-bezier(.25,.8,.25,1);
    transition-property: font-size,padding-top,color;
    font-family: inherit;
    font-size: 14px;
    line-height: 32px;
    height :130px;
    //margin-top:10px;
    width:100%;
    resize: none;
  }
  .user-info-box{
    height: 86px;
    padding-bottom: 0px;
    border-bottom:1px solid #d2d2d2 !important;
    margin: 0 16px;
  }
  h5.title{
    font-size: 14px;
    margin: 12px 4px;
    text-align: center;
    font-weight: 600;
  }
  .big-font{
    font-size: 18px;
  }
  .weigth-font{
    font-weight: 600;
  }
  .good-main-box.md-layout .md-layout-item{
    padding: 0 10px 0 10px;
    color: #777777;
  }
  .mobile-side .good-main-box.md-layout .md-layout-item{
    padding-left: 5px;
    padding-right: 5px;
  }
  .good-box{
    border: 2px solid #ccc;
    border-radius: 8px;
    margin: 6px 0; 
    padding: 12px 4px;
    font-size: 14px;
    cursor: pointer;
  }
  .right-side, .mobile-side{
    padding-left: 10px;
    overflow-y: auto;
    overflow-x: clip;
  }
  .search-box{
    padding-top: 5px;
    position: absolute;
    top:0;
    left:230px;
    height: 60px;
    right: 0;
    background: #ffffff;
  }
  .search-box.mobile{
    left: 190px
  }
  .fst-side.sec,.chat-side,.mobile-side,.right-side{
    // margin-top: 60px;
  }
  .fst-side.sec{
    max-height: calc( 100vh - 72px - 60px );
  }
  .submit-mark{
    background-color: #00bcd4;
    color: #ffffff;
    border: 0;
    position: absolute;
    bottom: 18px;
    right: 6px;
    //padding: 4px 12px;
    // border-radius: 6px;
    // cursor:pointer;
  }
  .round-box{
    display: inline-block;
    padding: 2px 16px;
    color: #fff;
    border-radius: 14px;
  }
  .round-box.info{
    background: #00bcd4;
  }
  .round-box.other{
    background-color: red;
  }
  .box>div{
    max-height: calc( 100vh - 72px );
    // overflow: auto;
    // overflow-x: hidden;
  }
  .box>div.max{
    max-height: calc( 100vh - 72px );
  }
  .go-page>div:hover{
    // background: #f4f4f4;
  }
  .go-page>div{
    cursor:pointer;
    // text-align:center;
    min-width: 50%;
    max-width: 50%;
    flex: 0 1 50%;
  }
  .sec-side.go-page{
    padding-left:0;
    padding-right:0;
    display: flex;
    margin-right: 8px;
  }
  .chat-box {
    margin-bottom: 10px;
    height: calc( 100vh - 370px );
    overflow: auto;
    overflow-x: hidden;
    margin-top: 10px;
  }
  // .chat-input-shadow{
  //   height: calc( 100vh - 102px - 111px - 67px );
  //   width: 100%;
  //   background: #ffffff;
  //   clear: both;
  // }
  .chat-input{
    border-top: 1px solid #d2d2d2 !important;
    clear: both;
    margin: 0 16px;
    clear: both;
    left: 0;
    right: 20px;
    width: auto;
    position: sticky;
    padding-bottom: 8px;
    // position: absolute;
    bottom: 0px;
    background: #ffffff;

  }
  .chat-side{
    /* padding-right: 8px; */
    position: relative;
    overflow-y: auto;
    max-height: calc( 100vh - 80px) !important;
    margin: 4px 8px;
    border-left: 1px solid #d2d2d2 !important;
    border-right: 1px solid #d2d2d2 !important;
    padding: 0 8px;
  }
  .two-box-info-box.textarea-box{
    box-sizing:border-box;
    padding-right: 12px;
  }
  .two-box-info-box.textarea-box textarea{ 
    padding-top: 10px !important;
  }
  .two-box-info-box.textarea-box>div{
    background-color: #efefef;
    border: 1px solid #eeeeee;
  }
  .two-box-info-box{
    min-width: 100%;
    max-width: 100%;
    flex: 0 1 100%;
    font-size: 12px;
  }
  .half-box.two-box-info-box{
    min-width: 50%;
    max-width: 50%;
    flex: 0 1 50%;
  }
  .two-box{
    display: flex;
    flex-wrap: wrap;
    padding-right: 10px;
  }
  .one-box-info-box label{
    color: #999999;
    padding-right: 12px;
    display: inline-block;
    min-width: 78px;
    text-align:right;
  }
  .one-box-info .one-box-info-box{
    margin-bottom: 8px;
    font-size: 12px;
    line-height: 22px;
  }
  .one-box-info{
    box-sizing: border-box;
    padding: 0 8px;
  }
  .one-box-img{
    width: 180px;
    height: 180px;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
  }
  .one-box-img img{
    max-width: 180px;
    max-height: 180px;
  }
  .mobile-side .one-box{
    height : unset;
  }
  .one-box{
    margin-top: 16px;
    display:flex;
    height: 200px;
    // align-items: stretch;
    align-items: center;
  }
  .chat-side, .right-side, .mobile-side{
    flex-grow: 1;
    // background-color: rgb(153, 153, 153);
  }
  .mobile-side .one-box-info-box label{
    text-align:left;
  }
  .mobile-side .one-box{
    justify-content: center;
    margin-bottom: 20px;
  }
  .mobile-side{
    max-width: 260px;
    background-color: #ffffff;
  }
  .right-side{
    max-width: 440px;
    background-color: #ffffff;
  }
  .sec .menu-item-box .menu-item-p{
    line-height: 12px;
    margin-bottom: 14px;
    margin-top: 4px;
    margin-left: 12px;
    font-size: 14px;
  }
  .menu-item-img{
    height: 44px;
    width: 44px;
    // background: #888;
  }
  .sec .menu-item-count{
    margin-left: auto;
    margin-top: 8px;
    height: 24px;
  }
  .menu-item-count{
    background: #f44336;
    color: #ffffff;
    float: right;
    padding: 0 8px;
    line-height: 24px;
    margin-top: 4px;
    border-radius: 4px;
    font-size: 12px;
    border: 0;
  }
  .sec .menu-item-box{
    height: 60px; 
    padding: 8px 12px;
    display: flex;
    margin-right: 8px;
  }
  .menu-item-box{
    font-size: 14px;
    height: 40px;
    margin: 6px 0;
    box-sizing: border-box;
    padding: 4px 12px;
    line-height: 32px;
    width: calc( 100% - 15px );
    cursor: pointer;
    border-radius: 4px;
    transition: background .2s;
  }
  .menu-item-box.selected{
    background: #00bcd4;
    color: #ffffff;
  }
  .menu-item-box:hover{
    background: #f4f4f4;
  }
  .menu-item-box.selected:hover{
    background: #00bcd4;
  }
  .box{
    display: flex;
    position: relative;
    width: 100%;
    min-height: calc( 100vh - 72px );
    background-color: #ffffff;
    align-items: stretch;
  }
  .mobile.fst-side{
    width: 200px;
  }
  .mobile.fst-side .sec-side{
    width: 160px;
  }
  .fst-side{
    overflow-y:hidden;
    width: 240px;
    display: flex;
    align-items: stretch;
  }
  .fst-side.sec{
     // width: 280px;
  }
  .fst-side.sec .main-box{
    padding-left: 0;
    overflow-y: auto;
    overflow-x: clip;
    margin-bottom: 80px;
  }
  .fst-side .main-box{
    // box-shadow: 0px 0 10px #a9a9a9;
    padding-left: 20px;
    margin-right: 10px;
    box-sizing:border-box;
  }
  .sec-side{
    font-size: 16px;
    font-weight: 300;
    height: 70px;
    width: 200px;
    box-sizing: border-box;
    padding: 15px 12px;
    line-height: 40px;
  }
  .sec .sec-side{
    width: 240px;
  }
  .right-line{
    margin-top: 16px;
    margin-bottom: 16px;
    content: "";
    height: 0px;
    width: calc(100% - 20px);
    margin-left: 5px;
    border-bottom: 2px rgba(180, 180, 180, 0.3) dashed;
  }
  .line{
    content: "";
    height: 1px;
    width: calc(100% - 15px);
    background-color: rgba(180, 180, 180, 0.3);
  }

    .right_box{
        margin: 8px 16px;
        width: 70%;
        max-width: 400px;
        float: right;
        clear: both;
    }
    .left_box{
        margin: 8px 16px;
        width: 70%;
        max-width: 400px;
        float: left;
        clear: both;
    }
    .name {
        font-size: 16px;
        line-height: 24px;
    }
    .right_box .name {
        //margin-right: 44px;
        text-align: right;
    }
    .left_box .name {
        //margin-left: 44px;
        text-align: left;
    }
    .message {
        max-width: calc(100% - 0px);
        // border: 2px solid #ccc;
        padding: 10px;
        color: #000000;
        background: #f2f2f2;
        border-radius: 5px;
        margin-top: 4px;
        line-height: 20px;
        font-size: 14px;
        word-wrap:break-word;
        text-align: left;
        float: left;
    }
    .right_box .message{
      float: right;
      background: rgb(190,228,247);
    }
    .face.left {
        float: left;
        margin-top: 4px;
    }

    .face.right {
        float: right;
        margin-top: 4px;
    }
    .time{
        clear: both;
        font-size: 12px; 
        color: #999;
    }
    .right_box .time{
       // margin-right: 44px; 
        text-align: right;
    }
    .left_box .time{
        //  margin-left: 44px; 
        text-align: left;
    }
</style>
